var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'bounce-animation' : _vm.playAnimation,
    'bounce-fixed-bottom': true,
    'bounce-bonus-text': true
  },attrs:{"id":"animation-container"}},[_vm._v(" +"+_vm._s(_vm.czxpAward)+" "),_c('img',{staticClass:"bounce-coin-size",attrs:{"src":"https://cryptoz.cards/assets/cryptokeeper_coin_binance.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }